import { useEffect, useMemo, useState } from 'react';
import { PlansAPI } from '../../api/payments/plans/api';
import { buildComparisonRows, groupPlansByCycle } from './utils';

// ponytail: pré-seleção prioriza o grupo mensal (cycleDays 30); sem mensal,
// cai pro primeiro ciclo disponível; planos inativos (ex.: Degustação) ficam
// fora. Cap simples nos N mais baratos do grupo
// pra tabela não ficar larga demais quando o catálogo crescer — pra comparar
// planos fora do default, dá pra marcar/desmarcar pelo checkbox de cada card.
const DEFAULT_COMPARISON_LIMIT = 6;

export function usePaymentPlansBootstrap() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [showInactive, setShowInactive] = useState(false);

  useEffect(() => {
    PlansAPI.list()
      .then((response) => {
        const content = response.data?.content || [];
        const sorted = [...content].sort((a, b) => a.amount - b.amount);
        setPlans(sorted);

        const monthlyPlans = sorted.filter((plan) => plan.cycleDays === 30);
        const defaultPlans =
          monthlyPlans.length > 0
            ? monthlyPlans
            : groupPlansByCycle(sorted)[0]?.plans || [];
        setSelectedIds(
          defaultPlans
            .filter((plan) => plan.active)
            .slice(0, DEFAULT_COMPARISON_LIMIT)
            .map((plan) => plan.id),
        );
      })
      .catch((error) => {
        setErrorMessage(
          'Não foi possível carregar os planos. Tente novamente.',
        );
        console.error('Erro ao buscar planos:', error);
      })
      .finally(() => setLoading(false));
  }, []);

  const toggleSelected = (id) =>
    setSelectedIds((current) =>
      current.includes(id)
        ? current.filter((value) => value !== id)
        : [...current, id],
    );

  // Plano inativo marcado no comparativo continua nele mesmo com o filtro ligado.
  const visiblePlans = useMemo(
    () => (showInactive ? plans : plans.filter((plan) => plan.active)),
    [plans, showInactive],
  );
  const inactiveCount = plans.filter((plan) => !plan.active).length;

  const selectedPlans = useMemo(
    () => plans.filter((plan) => selectedIds.includes(plan.id)),
    [plans, selectedIds],
  );

  const comparisonRows = useMemo(() => buildComparisonRows(selectedPlans), [
    selectedPlans,
  ]);

  return {
    plans,
    visiblePlans,
    inactiveCount,
    showInactive,
    setShowInactive,
    loading,
    errorMessage,
    selectedIds,
    toggleSelected,
    selectedPlans,
    comparisonRows,
  };
}
